import { DATE_KEY, dynamicVariableTag, escapeHtml, getVariableHtml } from "@simplyk/common";

import { Translate } from "@/common/hooks/useTranslate";

const FALLBACK_DATE_VARIABLE_TAG = dynamicVariableTag.getTag(`${DATE_KEY}-fallback-reminder`);

const REMINDER_KEYS = {
  1: {
    subject: "ticketing.reminder1.defaultSubject",
    subjectGeneric: "ticketing.reminder1.defaultSubjectGeneric",
    intro: "ticketing.reminder1.intro",
    introGeneric: "ticketing.reminder1.introGeneric",
  },
  2: {
    subject: "ticketing.reminder2.defaultSubject",
    subjectGeneric: "ticketing.reminder2.defaultSubjectGeneric",
    intro: "ticketing.reminder2.intro",
    introGeneric: "ticketing.reminder2.introGeneric",
  },
} as const;

export interface EventReminderFallback {
  subject: string;
  content: string;
}

interface BuildEventReminderFallbackParams {
  reminderNumber: 1 | 2;
  eventName: string;
  hasDate: boolean;
  t: Translate;
}

export const buildEventReminderFallback = ({
  reminderNumber,
  eventName,
  hasDate,
  t,
}: BuildEventReminderFallbackParams): EventReminderFallback => {
  const keys = REMINDER_KEYS[reminderNumber];
  const trimmedName = eventName.trim();
  const hasName = trimmedName.length > 0;

  const subject = hasName
    ? t("dashboard", keys.subject).replace(/\{\{eventName\}\}/g, trimmedName)
    : t("dashboard", keys.subjectGeneric);

  const intro = hasName
    ? t("dashboard", keys.intro).replace(/\{\{eventName\}\}/g, escapeHtml(trimmedName))
    : t("dashboard", keys.introGeneric);

  const dateLine = hasDate
    ? `<ul><li>🕐 ${getVariableHtml({
        text: t("dashboard", "ticketing.reminder.dateLabel"),
        tag: FALLBACK_DATE_VARIABLE_TAG,
      })}</li></ul>`
    : "";

  const content = [
    `<p>${t("dashboard", "ticketing.reminder.greeting")}</p>`,
    `<p>${intro}</p>`,
    dateLine,
    `<p>${t("dashboard", "ticketing.reminder.thankYou")}</p>`,
    `<p>${t("dashboard", "ticketing.reminder.closing")}</p>`,
  ]
    .filter(Boolean)
    .join("");

  return { subject, content };
};
